
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$list.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$list.js';
export default __default__;
